type ClientErrorPayload = {
    type: string;
    message: string;
    file?: string;
    line?: number;
    stack?: string;
};

export class ClientErrorLogger {
    public initEventListener() {
        window.addEventListener("error", (e) => {
            this.logError(e.error || e.message);
        });

        window.addEventListener("unhandledrejection", (e) => {
            this.logError(e.reason);
        });
    }

    public logError(error: unknown, context?: { messageType?: string; reason?: string; websocket?: WebSocket }): void {
        const payload = this.buildPayload(error, context);
        this.sendToServer(payload);
    }

    public logInfo(message: string, type: string = 'error', context?: { messageType?: string; reason?: string; websocket?: WebSocket }): void {
        this.sendToServer(this.buildPayload(message, context, type));
    }

    private buildPayload(error: unknown, context?: { messageType?: string; reason?: string; websocket?: WebSocket }, typeOverride?: string): ClientErrorPayload {
        let message = "Unknown error";
        let type: string = typeOverride || typeof error;
        let file: string | undefined = undefined;
        let line: number | undefined = undefined;
        let stack: string | undefined = undefined;

        if (error instanceof Error) {
            message = error.message;
            type = error.name;
            stack = error.stack ?? undefined;

            const match = error.stack?.match(/(https?:\/\/[^\s:]+):(\d+)/);
            if (match) {
                file = match[1];
                line = parseInt(match[2], 10);
            }
        } else if (typeof error === "string") {
            message = error;
            type = typeOverride || "StringError";
            stack = new Error(error).stack ?? undefined;
        }

        if (context?.messageType) {
            message += ` | messageType: ${context.messageType}`;
        }
        if (context?.reason) {
            message += ` | reason: ${context.reason}`;
        }
        if (context?.websocket) {
            message += ` | websocket.readyState: ${context.websocket.readyState}`;
            message += ` | websocket.url: ${context.websocket.url}`;
        }

        return {
            type,
            message,
            file,
            line,
            stack
        };
    }

    private async sendToServer(payload: ClientErrorPayload): Promise<void> {
        try {
            await fetch("/chat/error", {
                method: "POST",
                headers: {
                    "Content-Type": "application/json"
                },
                body: JSON.stringify(payload)
            });
        } catch (e) {
            // Nichts tun
        }
    }
}
